// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { HDC, ProductSpec } = initSchema(schema);

export {
  HDC,
  ProductSpec
};